exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mg.thumbnail:hover {\n  height: 350px; }\n\ntr.changed {\n  background-color: rgba(238, 238, 0, 0.67) !important; }\n\ntr.changed:nth-child(even) {\n  background-color: rgba(237, 237, 0, 0.67) !important; }\n\ntd.imutable {\n  color: #848484; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/translations/translations.component.scss
// module id = ../../../../../src/app/pages/translations/translations.component.scss
// module chunks = main